// extracted by mini-css-extract-plugin
export default {"container":"TopicBottomPanel_container__Ef68E","element":"TopicBottomPanel_element__zDile"};